import { convertToRaw, EditorState, ContentState } from 'draft-js';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

class DraftUtils {

  static editorState2HTML(editorState) {
    return draftToHtml(convertToRaw(editorState.getCurrentContent()));
  }

  static HTML2EditorState(html) {
    const { contentBlocks, entityMap } = htmlToDraft(html);

    return EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks, entityMap));
  }
}

export default DraftUtils;
